export const SUPPORTED_IMAGE_FORMATS = new Set(["jpeg", "png"]);
export const BIKE_DISPLAY_STATUS = [
  "PENDING",
  "APPROVED",
  "REJECTED",
  "DELETED",
];
